import script from "./RegisterUsersView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisterUsersView.vue?vue&type=script&lang=ts&setup=true"

import "./RegisterUsersView.vue?vue&type=style&index=0&id=cdbf2ab6&lang=scss"

const __exports__ = script;

export default __exports__